import { useI18n } from 'vue-i18n'

export default () => {
    const i18n = useI18n()

    return {
        '@type': 'ContactPoint',
        telephone: i18n.t('footer.customerSupport.phone'),
        email: i18n.t('footer.customerSupport.email'),
        contactType: 'customer service',
    }
}
